export default __webpack_public_path__ + "static/media/loading.81da48ab.gif";